import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	partnerWelcomeBannerSubtitle: {
		id: 'fastshift.dashboard.partner-welcome-banner.subtitle',
		defaultMessage:
			'Welcome to the FastShift Portal. Select a customer to view more details about their migration progress.',
		description: 'Subtitle for the partner welcome banner',
	},
});
